import { Checkbox as ReakitCheckbox } from 'reakit/Checkbox'
import styled from 'styled-components'
import { colors } from '~/styles/colors'

export const Label = styled.label({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  fontSize: '0.875rem',
  lineHeight: 1.7,
  color: colors.dark,
  overflowWrap: 'anywhere',
  cursor: 'pointer',

  '&[data-disabled="true"]': {
    opacity: 0.5,
    cursor: 'not-allowed',
  },

  '& > svg, & > span:first-child > svg': {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    left: 5,
  },

  '&[data-align-top="true"]': {
    display: 'grid',
    gridTemplateColumns: '22px minmax(0, 1fr)',
    columnGap: 14,
    alignItems: 'start',
  },

  '&[data-align-top="true"] input': {
    margin: 0,
  },

  '&[data-align-top="true"] > span:first-child > svg': {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
})

export const Control = styled.span({
  position: 'relative',
  display: 'flex',
  height: '1lh',
  // Optical alignment with the first line of text, only for opt-in controls.
  marginTop: '0.175lh',
  alignItems: 'center',
})

export const Checkmark = styled(ReakitCheckbox)({
  cursor: 'pointer',
  appearance: 'none',
  background: colors.white,
  borderRadius: 2,
  border: colors.border,
  outline: 'none',
  width: 22,
  height: 22,
  minWidth: 22,
  minHeight: 22,
  marginRight: 14,

  '&:hover': {
    borderColor: colors.slateGray,
  },

  '&:checked': {
    background: colors.primary.default,
    borderColor: colors.primary.default,
  },

  '&[data-invalid="true"]': {
    borderColor: colors.error,
  },

  // No background change: the checkmark icon sits on top of the box and is
  // white when unchecked, so a tinted box would show a phantom checkmark.
  '&:disabled': {
    cursor: 'not-allowed',
  },
})
